import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import { NumberInput } from '../Inputs/Inputs.jsx'
import AppDispatcher from '../../../dispatchers/AppDispatcher'

const RpmState = ({ device }) => {
  const [offRpm, setOffRpm] = useState(device.physical.offRpm)
  const [highRpm, setHighRpm] = useState(device.physical.highRpm)

  const appDispatch = useCallback(() => {
    let offRpmValue = device.physical.offRpm
    let highRpmValue = device.physical.highRpm
    if (Number.isInteger(Number(offRpm))) {
      offRpmValue = Number(offRpm)
    }
    if (Number.isInteger(Number(highRpm))) {
      highRpmValue = Number(highRpm)
    }

    AppDispatcher.dispatch({
      action: 'change-physical',
      setting: {
        offRpm: offRpmValue,
        highRpm: highRpmValue,
      },
    })
  }, [offRpm, highRpm, device.physical.offRpm, device.physical.highRpm])

  useEffect(() => {
    appDispatch()
  }, [offRpm, highRpm, appDispatch])

  const handleChange = useCallback((field, value, callback) => {
    if (field === 'offRpm') {
      setOffRpm(value)
    } else if (field === 'highRpm') {
      setHighRpm(value)
    }
  }, [])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  const unit = 'Speed'
  const steps = 1

  const labelOffRpm = 'Off Speed'
  const labelHighRpm = 'High Speed'

  return (
    <div>
      <section>
        <h3>
          Current Setting
        </h3>
        <ul>
          <li>
            <span>{labelOffRpm}</span>
            <span>
              {device.physical.offRpm}
              {unit}
            </span>
          </li>
          <li>
            <span>{labelHighRpm}</span>
            <span>
              {device.physical.highRpm}
              {unit}
            </span>
          </li>
        </ul>
      </section>
      <section>
        <h3>
          New Setting
        </h3>
        <ul>
          <li>
            <span>{labelOffRpm}</span>
            <span>
              <NumberInput
                value={offRpm}
                childChange={childChange}
                field='offRpm'
                steps={steps}
              />
              {unit}
            </span>
          </li>
          <li>
            <span>{labelHighRpm}</span>
            <span>
              <NumberInput
                value={highRpm}
                childChange={childChange}
                field='highRpm'
                steps={steps}
              />
              {unit}
            </span>
          </li>
        </ul>
      </section>
    </div>
  )
}

RpmState.propTypes = {
  device: PropTypes.object.isRequired,
}

export default RpmState
